import { importCompressor } from 'components/PhotoBank/lazy-compressorjs'

const STRONGER_COMPRESSION_THRESHOLD = 60 * 1024 * 1024

type Result = {
  file: File
  state: 'success' | 'error' | 'skipped' | 'timeout'
  error?: Error
}

export async function createThumbnail(
  file: File,
  options: { maxSizeMB: number },
  timeout: number = 60000
): Promise<Result> {
  if (options.maxSizeMB && file.size <= options.maxSizeMB * 1024 * 1024) {
    return { state: 'skipped', file }
  }

  const Compressor = await importCompressor()

  return await new Promise<Result>((resolve) => {
    let timeoutId: ReturnType<typeof setTimeout>
    const compressor = new Compressor(file, {
      quality: file.size <= STRONGER_COMPRESSION_THRESHOLD ? 0.99 : 0.8,
      success: (result) => {
        clearTimeout(timeoutId)
        const compressedFile =
          result instanceof File
            ? result
            : new File([result], file.name, { type: result.type })

        resolve({ state: 'success', file: compressedFile })
      },
      error: (error) => {
        clearTimeout(timeoutId)
        resolve({ state: 'error', file, error })
      },
      // causes OOM on mobile when true
      checkOrientation: false,
    })
    timeoutId = setTimeout(() => {
      try {
        compressor.abort()
      } catch (error) {
        // compressorjs throws if this.image is undefined when abort fires
        resolve({
          state: 'error',
          file,
          error: error instanceof Error ? error : new Error(String(error)),
        })
        return
      }
      resolve({ state: 'timeout', file })
    }, timeout)
  })
}
